import React from 'react';
import ChildSvg from '../svgs/ChildSvg';
import DollarSvg from '../svgs/DollarSvg';

const Bubble = ({ icon = 'Child' }) => {
  
  return (
    <div className='bubble-marker__container'>
      <div className="bubble-marker__bubble-container" style={{ width: "100%" }}>
        <svg viewBox="0 0 92.3 107" xmlns="http://www.w3.org/2000/svg" width="98" style={{ width: "98px" }}>
          <path
            d="M46.1 0a46.2 46.2 0 0 0-27.84 83l12.62 22.47h-.08l.9 1.5.9-1.5-.87-.49.85.5L40.37 92a47.73 47.73 0 0 0 5.73.32v.1A46.21 46.21 0 0 0 46.1 0z"
            fill="#fff"
          />
          <path
            d="M46.1 0a46.2 46.2 0 0 0-27.84 83l12.62 22.47h-.08l.9 1.5.9-1.5-.87-.49.85.5L40.37 92a47.73 47.73 0 0 0 5.73.32v.1A46.21 46.21 0 0 0 46.1 0zm0 90.4v-.1a40.16 40.16 0 0 1-6.1-.4l-.6-.1-.3.6.75.47-.85-.47-7.24 12.6-12-21.3-.8.47.77-.43-.1-.2-.2-.1a44.1 44.1 0 1 1 26.6 9z"
            fill="#ffa666"
          />
        </svg>
      </div>

      <div className='bubble-marker__icon-container' style={{ top: icon === 'Dollar' ? '25px' : '15px' }}>
        {icon === 'Dollar' ? <DollarSvg /> : <ChildSvg />}
      </div>
    </div>
  );
};

export default Bubble;
